/**
 * Formie date picker default fix.
 *
 * For a date picker with a non-ISO format (these forms use d/m/Y), Formie
 * renders the default value into the input in that format ("02/11/2026"), but
 * its picker script only understands ISO dates, so the browser reads it as
 * month/day and the field shows 11 February instead of 2 November (and a day
 * past the 12th would come out blank). This hands the picker the date parsed
 * the way it was written, before the picker is created.
 */
document.addEventListener('formie:field:date-picker:before-init', (event) => {
    const { datepicker, options } = event.detail ?? {};
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(datepicker?.value ?? '');

    if (!options) {
        return;
    }

    options.allowInput = true;

    if (!match) {
        return;
    }

    const [, day, month, year] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day));

    // Reject rollovers such as 31/02/2026.
    if (date.getDate() === Number(day)) {
        options.defaultDate = date;
    }
});
